export class SelectedListItem {
    id: number;
    beteckning: string;
    checked: boolean;

    constructor(
        id: number,
        beteckning: string,
        checked: boolean) {
        this.id = id;
        this.beteckning = beteckning;
        this.checked = checked;
    }
}
